import { render } from "./Portfolio_card.vue?vue&type=template&id=f2e6d7c4&ts=true"
import script from "./Portfolio_card.vue?vue&type=script&lang=ts"
export * from "./Portfolio_card.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__